(() => {
  const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const initSection = (section) => {
    if (!section) return;
    if (section.dataset.initialized === "true") return;
    section.dataset.initialized = "true";

    const closeButton = section.querySelector(".newsletter-signup__close");
    const openButton = section.querySelector(".newsletter-signup__toggle--open");
    const hideButton = section.querySelector(".newsletter-signup__toggle--hide");
    const form = section.querySelector(".newsletter-signup__form");
    const submitButton = section.querySelector(".newsletter-signup__submit");
    const successMessage = section.querySelector(".newsletter-signup__message--success");
    const errorMessage = section.querySelector(".newsletter-signup__message--error");
    const hasFeedback = section.querySelector(
      ".newsletter-signup__message--success:not([hidden]), .newsletter-signup__message--error:not([hidden])"
    );
    const mediaQuery = window.matchMedia("(max-width: 1149px)");

    const setCollapsed = (collapsed) => {
      if (!mediaQuery.matches) {
        section.classList.remove("is-collapsed");
        return;
      }
      section.classList.toggle("is-collapsed", collapsed);
    };

    if (hasFeedback) {
      section.classList.remove("is-collapsed");
    }

    closeButton?.addEventListener("click", () => {
      section.hidden = true;
    });

    openButton?.addEventListener("click", () => {
      setCollapsed(false);
    });

    hideButton?.addEventListener("click", () => {
      setCollapsed(true);
    });

    mediaQuery.addEventListener("change", () => {
      if (!mediaQuery.matches) {
        section.classList.remove("is-collapsed");
      }
    });

    const hideMessages = () => {
      if (successMessage) {
        successMessage.hidden = true;
      }
      if (errorMessage) {
        errorMessage.hidden = true;
        errorMessage.textContent = "";
      }
    };

    const showError = (message) => {
      if (!errorMessage) return;
      errorMessage.textContent = message;
      errorMessage.hidden = false;
    };

    const setLoading = (loading) => {
      if (!submitButton) return;
      submitButton.disabled = loading;
      submitButton.classList.toggle("is-loading", loading);
      section.classList.toggle("is-submitting", loading);
    };

    const getErrorMessage = async (response, fallback) => {
      try {
        const payload = await response.json();
        const detail = payload?.errors?.[0]?.detail;
        return detail || fallback;
      } catch (error) {
        return fallback;
      }
    };

    form?.addEventListener("submit", async (event) => {
      event.preventDefault();
      hideMessages();

      const companyId = (section.dataset.klaviyoCompanyId || "").trim();
      const listId = (section.dataset.klaviyoListId || "").trim();
      const revision = (section.dataset.klaviyoRevision || "2026-04-15").trim();
      const invalidEmailMessage =
        section.dataset.errorInvalidEmail || "Please enter a valid email address.";
      const submitErrorMessage =
        section.dataset.errorSubmit || "Something went wrong. Please try again.";

      if (!companyId || !listId) {
        showError("Klaviyo is not configured. Please set company ID and list ID in theme settings.");
        return;
      }

      const formData = new FormData(form);
      const email = (formData.get("email") || "").toString().trim();
      const firstName = (formData.get("first_name") || "").toString().trim();
      const lastName = (formData.get("last_name") || "").toString().trim();

      if (!EMAIL_REGEX.test(email)) {
        showError(invalidEmailMessage);
        return;
      }

      setLoading(true);

      try {
        const response = await fetch(
          `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(companyId)}`,
          {
            method: "POST",
            headers: {
              revision,
              "content-type": "application/json",
            },
            body: JSON.stringify({
              data: {
                type: "subscription",
                attributes: {
                  profile: {
                    data: {
                      type: "profile",
                      attributes: {
                        email,
                        first_name: firstName,
                        last_name: lastName,
                      },
                    },
                  },
                },
                relationships: {
                  list: {
                    data: {
                      type: "list",
                      id: listId,
                    },
                  },
                },
              },
            }),
          }
        );

        if (response.status === 202) {
          form.reset();
          if (successMessage) {
            successMessage.hidden = false;
          }
          return;
        }

        const apiMessage = await getErrorMessage(response, submitErrorMessage);
        showError(apiMessage);
      } catch (error) {
        showError(submitErrorMessage);
      } finally {
        setLoading(false);
      }
    });
  };

  const initAll = () => {
    document.querySelectorAll(".newsletter-signup").forEach(initSection);
  };

  document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("shopify:section:load", (event) => {
    initSection(event.target.querySelector(".newsletter-signup"));
  });
})();
